module.exports = __webpack_public_path__ + "img/fo.8f009344.svg";